// src/components/wall/CaptainVsTeamComponent.jsx
import { useEffect, useMemo, useState } from "react";

const ASSETS = {
  alphawolvesBullmasters: "/CaptainVsTeam/alphawolves-bullmasters.svg",
  alphawolvesCaptainPlayerBox:
    "/CaptainVsTeam/alphawolves-captain-player-box.svg",
  alphawolvesCaptainRightBanner:
    "/CaptainVsTeam/alphawolves-captain-right-banner.svg",
  alphawolvesGoldeneagles: "/CaptainVsTeam/alphawolves-goldeneagles.svg",
  alphawolvesIronbears: "/CaptainVsTeam/alphawolves-ironbears.svg",
  alphawolvesLeftBanner: "/CaptainVsTeam/alphawolves-left-banner.svg",
  alphawolvesLeftLogo: "/CaptainVsTeam/alphawolves-left-logo.svg",
  alphawolvesRightSymbol: "/CaptainVsTeam/alphawolves-right-symbol.svg",

  bullmastersAlphawolves: "/CaptainVsTeam/bullmasters-alphawolves.svg",
  bullmastersCaptainPlayerBox:
    "/CaptainVsTeam/bullmasters-captain-player-box.svg",
  bullmastersCaptainRightBanner:
    "/CaptainVsTeam/bullmasters-captain-right-banner.svg",
  bullmastersGoldeneagles: "/CaptainVsTeam/bullmasters-goldeneagles.svg",
  bullmastersIronbears: "/CaptainVsTeam/bullmasters-ironbears.svg",
  bullmasterLeftBanner: "/CaptainVsTeam/bullmasters-left-banner.svg",
  bullmasterLeftLogo: "/CaptainVsTeam/bullmasters-left-logo.svg",
  bullmastersRightSymbol: "/CaptainVsTeam/bullmasters-right-symbol.svg",

  goldeneaglesAlphawolves: "/CaptainVsTeam/goldeneagles-alphawolves.svg",
  goldeneaglesCaptainPlayerBox:
    "/CaptainVsTeam/goldeneagles-captain-player-box.svg",
  goldeneaglesCaptainRightBanner:
    "/CaptainVsTeam/goldeneagles-captain-right-banner.svg",
  goldeneaglesBullmasters: "/CaptainVsTeam/goldeneagles-bullmasters.svg",
  goldeneaglesIronbears: "/CaptainVsTeam/goldeneagles-ironbears.svg",
  goldeneaglesLeftBanner: "/CaptainVsTeam/goldeneagles-left-banner.svg",
  goldeneaglesLeftLogo: "/CaptainVsTeam/goldeneagles-left-logo.svg",
  goldeneaglesRightSymbol: "/CaptainVsTeam/goldeneagles-right-symbol.svg",

  ironbearsAlphawolves: "/CaptainVsTeam/ironbears-alphawolves.svg",
  ironbearsCaptainPlayerBox: "/CaptainVsTeam/ironbears-captain-player-box.svg",
  ironbearsCaptainRightBanner:
    "/CaptainVsTeam/ironbears-captain-right-banner.svg",
  ironbearsBullmasters: "/CaptainVsTeam/ironbears-bullmasters.svg",
  ironbearsGoldeneagles: "/CaptainVsTeam/ironbears-goldeneagles.svg",
  ironbearsLeftBanner: "/CaptainVsTeam/ironbears-left-banner.svg",
  ironbearsLeftLogo: "/CaptainVsTeam/ironbears-left-logo.svg",
  ironbearsRightSymbol: "/CaptainVsTeam/ironbears-right-symbol.svg",

  vs: "/CaptainVsTeam/vs.svg",
  vsBanner: "/CaptainVsTeam/vs-banner.svg",
};

// --- کمک‌تابع‌ها ---
const TEAM_KEYS = ["ironbears", "alphawolves", "bullmasters", "goldeneagles"];

function leftPrefixKey(key) {
  return key === "bullmasters" ? "bullmaster" : key;
}

/** مپ کردن جفت (left-right) به کلید موجود در ASSETS */
function getPairSrc(leftKey, rightKey) {
  if (!leftKey || !rightKey) return "";
  const left = leftPrefixKey(leftKey);
  const right = rightKey; // سمت راست همان شکل جمع می‌ماند
  const key = `${left}${capitalize(right)}`;
  return ASSETS[key] || "";
}

function capitalize(s) {
  return s ? s[0].toUpperCase() + s.slice(1) : s;
}

/** بنر و لوگوی سمت چپ */
function getLeftBannerSrc(k) {
  if (!k) return "";
  const left = leftPrefixKey(k);
  const key = `${left}LeftBanner`;
  return ASSETS[key] || "";
}
function getLeftLogoSrc(k) {
  if (!k) return "";
  const left = leftPrefixKey(k);
  const key = `${left}LeftLogo`;
  return ASSETS[key] || "";
}

/** سمبل‌ها */
function getRightSymbolSrc(k) {
  if (!k) return "";
  const key = `${k}RightSymbol`;
  return ASSETS[key] || "";
}

/** با این‌که در ASSETS نبود، طبق نمونهٔ شما، الگوی فایل سمبلِ سمت چپ چنین است: team-left-symbol.svg */
function getLeftSymbolSrc(k) {
  if (!k) return "";
  return `/CaptainVsTeam/${k}-left-symbol.svg`;
}

/** کاپیتان سمت راست */
function getCaptainRightBannerSrc(k) {
  if (!k) return "";
  const key = `${k}CaptainRightBanner`;
  return ASSETS[key] || "";
}
function getCaptainPlayerBoxSrc(k) {
  if (!k) return "";
  const key = `${k}CaptainPlayerBox`;
  return ASSETS[key] || "";
}

export default function CaptainVsTeamComponent() {
  // وضعیت نمایش
  const [visible, setVisible] = useState(false);

  // دادهٔ دیوار
  const [leftTeamKey, setLeftTeamKey] = useState(""); // ironbears | alphawolves | bullmasters | goldeneagles
  const [leftTeamName, setLeftTeamName] = useState("—");

  const [rightTeamKey, setRightTeamKey] = useState("");
  const [rightCaptain, setRightCaptain] = useState(null); // { first_name, last_name, username, avatar }

  // شنود رویدادها (CustomEvent + BroadcastChannel)
  useEffect(() => {
    const onShow = () => setVisible(true);
    const onData = (e) => {
      const p = e?.detail || {};
      // قرارداد: { left: {type:'team', teamKey, teamName}, right: {type:'captain', teamKey, teamName, captain:{...}} }
      if (p?.left?.teamKey && p?.right?.teamKey) {
        setLeftTeamKey(p.left.teamKey);
        setLeftTeamName(p.left.teamName || "—");
        setRightTeamKey(p.right.teamKey);
        setRightCaptain(p.right.captain || null);
        setVisible(true); // اگر داده قبل از SHOW بیاید، باز هم نمایش بده
      }
    };

    window.addEventListener("SHOW_CAPTAIN_VS_TEAM", onShow);
    window.addEventListener("DAY7_SET_MATCHUP", onData);

    let bc;
    try {
      bc = new BroadcastChannel("operator-events");
      bc.onmessage = (msg) => {
        const { actionId, payload } = msg.data || {};
        if (actionId === "SHOW_CAPTAIN_VS_TEAM") onShow();
        if (actionId === "DAY7_SET_MATCHUP") onData({ detail: payload });
      };
    } catch {}

    return () => {
      window.removeEventListener("SHOW_CAPTAIN_VS_TEAM", onShow);
      window.removeEventListener("DAY7_SET_MATCHUP", onData);
      try {
        bc && bc.close();
      } catch {}
    };
  }, []);

  // محاسبهٔ مسیر تصاویر بر اساس انتخاب‌ها
  const leftSymbolSrc = useMemo(
    () => getLeftSymbolSrc(leftTeamKey),
    [leftTeamKey]
  );
  const leftBannerSrc = useMemo(
    () => getLeftBannerSrc(leftTeamKey),
    [leftTeamKey]
  );
  const leftLogoSrc = useMemo(() => getLeftLogoSrc(leftTeamKey), [leftTeamKey]);
  const centerPairSrc = useMemo(
    () => getPairSrc(leftTeamKey, rightTeamKey),
    [leftTeamKey, rightTeamKey]
  );
  const rightBannerSrc = useMemo(
    () => getCaptainRightBannerSrc(rightTeamKey),
    [rightTeamKey]
  );
  const rightPlayerBoxSrc = useMemo(
    () => getCaptainPlayerBoxSrc(rightTeamKey),
    [rightTeamKey]
  );
  const rightSymbolSrc = useMemo(
    () => getRightSymbolSrc(rightTeamKey),
    [rightTeamKey]
  );

  // نام کاپیتان
  const captainName = useMemo(() => {
    if (!rightCaptain) return "نام و نام‌خانوادگی";
    const { first_name = "", last_name = "", username = "" } = rightCaptain;
    const full = `${first_name} ${last_name}`.trim();
    return full || username || "نام و نام‌خانوادگی";
  }, [rightCaptain]);

  const captainAvatar = rightCaptain?.avatar || "/avatar/avatar-default.webp";

  if (!visible) return null;

  return (
    <div className="w-full h-full flex items-center justify-center relative">
      {/* سمبل سمت چپ */}
      {leftSymbolSrc ? (
        <img
          src={leftSymbolSrc}
          className=" absolute left-[20%] z-[22]"
          alt=""
        />
      ) : null}

      <div className="w-[820px] flex items-center justify-center">
        <div className="team-title">
          <span
            style={{ fontFamily: "Etemad" }}
            className="text-[#FFFFFF] text-[18px] font-normal absolute z-[6] left-[40%] top-[50%] -translate-x-1/2 -translate-y-1/2"
          >
            {String(leftTeamName || "").toUpperCase()}
          </span>
        </div>

        {/* بنر و لوگوی سمت چپ */}
        {leftBannerSrc ? (
          <img
            className=" absolute left-[42%] -translate-x-1/2"
            src={leftBannerSrc}
            alt=""
          />
        ) : null}
        {leftLogoSrc ? (
          <img
            className=" absolute left-[34%] mt-[0] -translate-x-1/2"
            src={leftLogoSrc}
            alt=""
          />
        ) : null}

        <div className="relative w-[546px] flex items-center justify-center">
          <img
            className="absolute w-[480px] z-[3] bottom-[60px] left-1/2 -translate-x-1/2 -transtale-y-1/2"
            src={ASSETS.vsBanner}
            alt=""
          />
          <img className="relative w-[346px] z-[4]" src={ASSETS.vs} alt="" />
          {centerPairSrc ? (
            <img
              className=" absolute z-[3] w-[346px] bottom-[42px] left-1/2 -translate-x-1/2 -transtale-y-1/2"
              src={centerPairSrc}
              alt=""
            />
          ) : null}
        </div>
      </div>

      {/* بنر کاپیتان سمت راست */}
      {rightBannerSrc ? (
        <img
          className=" absolute right-[32%] -translate-x-1/2"
          src={rightBannerSrc}
          alt=""
        />
      ) : null}

      {/* باکس بازیکن (کاپیتان) سمت راست */}
      {rightPlayerBoxSrc ? (
        <img
          className=" absolute right-[31%] mt-[12px] -translate-x-1/2"
          src={rightPlayerBoxSrc}
          alt=""
        />
      ) : null}

      {/* سمبل سمت راست */}
      {rightSymbolSrc ? (
        <img
          src={rightSymbolSrc}
          className=" absolute right-[15%] z-[22] translate-x-[-50%]"
          alt=""
        />
      ) : null}

      {/* آواتار کاپیتان */}
      <img
        className=" absolute right-[34.5%] mb-[42px] w-[74px]"
        src={captainAvatar}
        alt=""
      />

      {/* نام کاپیتان */}
      <div className="team-title">
        <span className="drop-shadow-lg w-[200px] text-[#FFFFFF] text-[20px] font-normal text-right absolute z-[6] right-[36%] top-[50%] -translate-x-1/2 -translate-y-1/2">
          {captainName}
        </span>
      </div>
    </div>
  );
}
